import { STORE_CONFIG } from '@/config/storeConfig';
import { buildProductShareUrl } from '@/utils/shareLinks';

// Single source for the store's WhatsApp number — wa.me wants digits only (27613215050).
const WHATSAPP_DIGITS = STORE_CONFIG.contact.whatsapp.replace(/\D/g, '');

export const GENERAL_WHATSAPP_MESSAGE = "Hallo, ek het 'n navraag vanaf die webwerf";

export const buildWhatsAppUrl = (message?: string): string =>
  message
    ? `https://wa.me/${WHATSAPP_DIGITS}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${WHATSAPP_DIGITS}`;

// Product enquiry to the store's WhatsApp. Staff need both codes: WS to find it on the site,
// Omni (stock_code) to find it in Omni. The link goes last so WhatsApp previews it, and uses
// the feed. Worker share URL (per-product preview, then redirects to the product page).
// Without a WS code it falls back to the previous apex product URL.
export const buildProductEnquiryUrl = (
  productName: string,
  wsCode: string | null | undefined,
  stockCode: string | null | undefined,
): string => {
  const link = wsCode
    ? buildProductShareUrl(wsCode)
    : `https://veevoerwinkel.co.za/products/${wsCode}`;
  return buildWhatsAppUrl(
    `Hallo, ek stuur 'n navraag oor ${productName} ` +
      `(WS: ${wsCode}, Omni: ${stockCode}) vanaf die webwerf: ` +
      link,
  );
};
